export const IconFullScreen = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true">
        <path
            d="m2,9.5v-3.5c0-1.1.9-2,2-2h3.5c.28,0,.5.22.5.5v1c0,.28-.22.5-.5.5h-3.5v3.5c0,.28-.22.5-.5.5h-1c-.28,0-.5-.22-.5-.5Z"
            className="fill-current group-hover/fullscreen:-translate-x-0.5 group-hover/fullscreen:-translate-y-0.5 motion-safe:transition-transform duration-200 ease-in-out"
        />
        <path
            d="m16.5,4h3.5c1.1,0,2,.9,2,2v3.5c0,.28-.22.5-.5.5h-1c-.28,0-.5-.22-.5-.5v-3.5h-3.5c-.28,0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5Z"
            className="fill-current group-hover/fullscreen:translate-x-0.5 group-hover/fullscreen:-translate-y-0.5 motion-safe:transition-transform duration-200 ease-in-out"
        />
        <path
            d="m22,14.5v3.5c0,1.1-.9,2-2,2h-3.5c-.28,0-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5h3.5v-3.5c0-.28.22-.5.5-.5h1c.28,0,.5.22.5.5Z"
            className="fill-current group-hover/fullscreen:translate-x-0.5 group-hover/fullscreen:translate-y-0.5 motion-safe:transition-transform duration-200 ease-in-out"
        />
        <path
            d="m7.5,20h-3.5c-1.1,0-2-.9-2-2v-3.5c0-.28.22-.5.5-.5h1c.28,0,.5.22.5.5v3.5h3.5c.28,0,.5.22.5.5v1c0,.28-.22.5-.5.5Z"
            className="fill-current group-hover/fullscreen:-translate-x-0.5 group-hover/fullscreen:translate-y-0.5 motion-safe:transition-transform duration-200 ease-in-out"
        />
    </svg>
);
